/**
 *
 *  EmailPreferences/Setters/Category
 *
 */

import React from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
import Toggle from 'react-toggle'
import update from 'immutability-helper'

// Graphql
import { gql, useMutation } from '@apollo/client'

// Utils
import { notify } from 'utils/notify'
import { underscore } from 'components/utils'

const UPDATE_COMMUNICATION_PREFERENCE = gql`
	mutation updateCommunicationPreference($id: ID!, $contact_emails: JSON) {
		updateCommunicationPreference(input: { id: $id, contact_emails: $contact_emails }) {
			communication_preference {
				id
				contact_emails
			}
		}
	}
`

function CategorySetter({ communication_preference: { id, contact_emails }, category_name, category_title, disabled }) {
	const CATEGORY = underscore(category_name.toUpperCase())

	const [mutate] = useMutation(UPDATE_COMMUNICATION_PREFERENCE, {
		onCompleted: ({ updateCommunicationPreference }) => {
			const status = updateCommunicationPreference.communication_preference.contact_emails[CATEGORY]

			notify({
				message: `${category_title} Emails ${status ? 'Will Be Sent' : 'Turned Off'}.`,
			})
		},
	})

	const updateContactEmails = (value, checked) => {
		mutate({
			variables: {
				id,
				contact_emails: update(contact_emails, {
					[value]: { $set: checked },
				}),
			},
		})
	}

	return (
		<Toggle
			value={CATEGORY}
			checked={contact_emails[CATEGORY]}
			onChange={(e) => !disabled && updateContactEmails(e.target.value, e.target.checked)}
			disabled={disabled}
		/>
	)
}

CategorySetter.propTypes = {
	communication_preference: PropTypes.object,
	category_name: PropTypes.string,
	category_title: PropTypes.string,
	disabled: PropTypes.bool,
}

export default CategorySetter
